import ADIProductSaleInfo, { TagsStyles } from "@NA/Components/ProductList/ADIProductSaleInfo";
import { ProductPriceStyles } from "@NA/Overrides/Components/ProductPrice";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import {
    HasProduct,
    HasProductContext,
    withProduct,
    withProductContext,
} from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import ProductPrice from "@insite/content-library/Components/ProductPrice";
import { ProductDetailsPageContext } from "@insite/content-library/Pages/ProductDetailsPage";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import getColor from "@insite/mobius/utilities/getColor";
import * as React from "react";
import { ResolveThunks, connect, useSelector } from "react-redux";
import { css } from "styled-components";
import { isPriceAvailable } from "@NA/Utils/Utility";
import translate from "@insite/client-framework/Translate";
import { Button, Link, Typography } from "@insite/mobius/index";
import { breakpointMediaQueries, getProp } from "@insite/mobius/utilities";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { ButtonPresentationProps } from "@insite/mobius/Button";
import toggleLoginDrawer from "@NA/Handlers/ADILoginDrawerHandler";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import { LinkPresentationProps } from "@insite/mobius/Link";
import ADIColors from "@NA/Utils/ADIColors";
import parse from "html-react-parser";
import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import CustomApplicationState from "@NA/Store/Data/CustomApplicationState/CustomApplicationState";
import { isProductInventoryOnlyRole } from "@NA/Widgets/MyAccount/ADIMyAccount";
type OwnProps = HasProduct &
    WidgetProps &
    HasProductContext &
    ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps>;

const mapStateToProps = (state: ApplicationState) => ({
    productSettings: getSettingsCollection(state).productSettings,
    isAuthenticated: state.context.session!.isAuthenticated,
    currencySymbol: state.context.session.currency?.currencySymbol ?? "",
    roles: state.context.session.userRoles,
});

const mapDispatchToProps = {
    toggleLoginDrawer,
};

export interface ProductDetailsPriceStyles {
    productPrice?: ProductPriceStyles;
    pricingMainWrapper?: InjectableCss;
    pdpWebMessageStyles?: InjectableCss;
    pdpMinimumQTYStyles?: InjectableCss;
    pendingVerficationStyle?: InjectableCss;
    pdpTagStyles?: TagsStyles;
    priceAvailibility?: InjectableCss;
    priceAvailibilityRightSection?: InjectableCss;
    beforeLoginRightSection?: InjectableCss;
    loginToSeePriceButton?: ButtonPresentationProps;
    signInHeading?: TypographyPresentationProps;
    signInLink?: LinkPresentationProps;
    divider?: InjectableCss;
    realTimeText?: InjectableCss;
    discontinuedmsg?: InjectableCss;
    VerificationText?: TypographyPresentationProps;
}

export const priceStyles: ProductDetailsPriceStyles = {
    discontinuedmsg: {
        css: css`
            font-size: 14px;
            line-height: 20px;
            color: #2d2926;
            font-weight: 600;
            font-family: "Open Sans", sans-serif;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            margin: 0px 0px 0px 10px;
        `,
    },
    VerificationText: {
        css: css`
                           
                                text-transform: none !important;
                                font-size: 16px !important;
                                font-weight: bold;
                                color: ${ADIColors.blue5} !important; 
                                margin: auto;                             
                            }
                        `,
    },
    pendingVerficationStyle: {
        css: css`
            font-family: "Nunito Sans", sans-serif;
            font-size: 20px !important;
            font-style: normal;
            font-weight: 700 !important;
            color: ${ADIColors.darkBlue1};
            line-height: normal;
            text-align: center;
            padding-bottom: 12px;
        `,
    },
    productPrice: {
        priceWrapperCustom: {
            css: css`
                display: flex;
                flex-direction: row;
                gap: 10px;
                width: auto;
                > div {
                    > div {
                        sup[class^="TypographyStyle"] {
                            margin-top: 0;
                            font-size: 18px;
                            line-height: normal;
                            font-weight: normal;
                            color: ${ADIColors.gray4};
                        }
                    }
                }
            `,
        },
        price: {
            priceText: {
                css: css`
                    flex-direction: row;
                    flex-wrap: wrap;
                    display: flex;
                    color: ${getColor("text.main")};
                    font-weight: 900;
                    sup {
                        font-size: 18px;
                    }
                    sup:first-child {
                        display: inline-block;
                        font-size: 18px;
                        line-height: 20px;
                        font-weight: 900;
                        color: ${getColor("text.main")};
                    }
                    span {
                        font-size: 36px;
                        line-height: 30px;
                        font-weight: 900;
                        color: ${getColor("text.main")};
                        margin: 0 2px;
                    }
                    sup:last-child {
                        margin-left: 0px;
                        font-size: 18px;
                        line-height: 20px;
                        font-weight: 900;
                        color: ${getColor("text.main")};
                    }
                    .currencyText {
                        margin-top: -4px;
                    }
                    .unitofmeasureText {
                        margin-top: -4px !important;
                    }
                `,
            },
            unitOfMeasureText: { size: 26 },
        },
        msrPriceTextStyle: {
            css: css`
                font-size: 14px;
                font-weight: 600 !important;
                color: ${ADIColors.gray25} !important;
            `,
        },
    },
    pricingMainWrapper: {
        css: css`
            display: inline-flex;
            flex-direction: row;
            flex-wrap: wrap;
            position: relative;
            width: 100%;
            flex-direction: row;
        `,
    },
    pdpWebMessageStyles: {
        css: css`
            font-size: 16px;
            font-weight: 400;
            line-height: 25.6px;
            padding-bottom: 20px;
            color: ${ADIColors.darkBlack3};
        `,
    },
    pdpMinimumQTYStyles: {
        css: css`
            font-size: 16px;
            font-weight: 400;
            line-height: 25.6px;
            padding-top: 10px;
            color: ${ADIColors.darkBlack3};
        `,
    },
    pdpTagStyles: {
        tagsContainer: {
            css: css`
                position: static;
                margin-right: 0px;
                ${TypographyStyle} {
                    margin-right: 10px;
                }
            `,
        },
    },
    priceAvailibility: {
        css: css`
            margin-top: 10px;
            font-weight: bold;
            font-size: ${getProp("theme.typography.headerSecondary.size")};
            background: ${getColor("text.disabled")};
            height: 55px;
            display: flex;
            align-items: center;
            justify-content: center;
            span {
                font-weight: bold;
                font-size: ${getProp("theme.typography.headerSecondary.size")};
            }
        `,
    },
    priceAvailibilityRightSection: {
        css: css`
            display: flex;
            flex-direction: column;
            flex-wrap: wrap;
            position: relative;
            width: 100%;
            justify-content: center;
            align-items: center;
            gap: 10px;
            background: ${getColor("text.disabled")};
            padding: 10px;
            h1 {
                font-weight: bold;
                font-size: ${getProp("theme.typography.headerSecondary.size")};
            }
            span {
                font-size: 10px;
            }
        `,
    },
    beforeLoginRightSection: {
        css: css`
            display: flex;
            flex-direction: column;
            flex-wrap: wrap;
            position: relative;
            width: 100%;
            justify-content: center;
            align-items: center;
            gap: 21px;
        `,
    },
    loginToSeePriceButton: {
        variant: "primary",
        css: css`
            min-width: 259px;
            width: 259px;
            border-radius: 4px;
            height: 40px;
            margin-bottom: 20px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        width: 100%;
                    `,
                    css`
                        width: 100%;
                    `,
                    css`
                        width: 259px;
                    `,
                    css`
                        width: 259px;
                    `,
                    null,
                ])}
        `,
    },
    signInHeading: {
        css: css`
            padding: 0 !important;
            font-size: 24px !important;
            font-weight: bold !important;
            line-height: 40px !important;
            text-align: center;
            margin: 0 auto;
            text-wrap: nowrap;
        `,
    },
    signInLink: {
        css: css`
            font-size: 14px !important;
            line-height: normal !important;
            font-weight: 600 !important;
            text-decoration: none !important;
            color: ${ADIColors.darkBlue1} !important;
            margin-left: 0;
            ${TypographyStyle} {
                color: ${ADIColors.darkBlue1} !important;
            }
        `,
    },
    divider: {
        css: css`
            width: 100%;
            border-bottom: 1px solid ${ADIColors.gray2};
        `,
    },
    realTimeText: {
        css: css`
            display: inline-block;
            text-align: left;
            min-width: 25px;
            min-height: 30px;
            font-size: 18px;
            line-height: 20px;
            font-weight: 900;
            color: #2d2926;

            &::after {
                overflow: hidden;
                display: inline-block;
                vertical-align: bottom;
                animation: ellipsis steps(4, end) 900ms infinite;
                content: "";
                width: 0;
            }

            @keyframes ellipsis {
                to {
                    width: 1.25em;
                }
            }
        `,
    },
};

const styles = priceStyles;

const ProductDetailsPrice: React.FC<OwnProps> = ({
    productContext,
    productSettings,
    product,
    isAuthenticated,
    currencySymbol,
    toggleLoginDrawer,
    roles,
}) => {
    const pricingLoading = !productContext.productInfo.pricing;
    const pricingIsAvailable = isPriceAvailable(
        productContext.productInfo.pricing,
        productContext.productInfo.qtyOrdered,
    );
    const pricing = productContext.productInfo?.pricing || product.pricing;

    const onLogintoSeePriceClick = () => {
        toggleLoginDrawer({ loginDrawer: true });
    };
    const pricingError = productContext.productInfo.failedToLoadPricing || (!pricingIsAvailable && !pricingLoading);
    const discontiuedmsg = product.properties["inventoryMessage"];

    const [updatedPDPWebMessage, setUpdatedPDPWebMessgae] = React.useState("");
    const isPendingVerification = useSelector(
        (state: CustomApplicationState) => state.ADIGlobalData.PricingStatusStore.isPendingVerification,
    );
    const getCustomerCreditStatus = useSelector(
        (state: CustomApplicationState) => state.ADIGlobalData.PricingStatusStore,
    );
    React.useEffect(() => {
        if (product.properties.pdpWebmessage) {
            let webMessage = "";
            let message = product.properties.pdpWebmessage.split("|");
            let currentDate = new Date();
            let webMsgStartDate = new Date(message[1]);
            let webMsgEndDate = new Date(message[2]);
            if (
                Date.parse(currentDate.toLocaleDateString()) <= Date.parse(webMsgEndDate.toLocaleDateString()) &&
                Date.parse(currentDate.toLocaleDateString()) >= Date.parse(webMsgStartDate.toLocaleDateString())
            ) {
                webMessage = message[0].toString();
            } else {
                webMessage = "";
            }
            setUpdatedPDPWebMessgae(webMessage);
        }
    }, [product.properties.pdpWebmessage]);

    const isPunchoutRole = (roles: any): boolean => {
        if (roles) {
            const trimmedInput = roles.trim().toLowerCase();
            return trimmedInput.includes("punchout");
        }
        return false;
    };

    const displayMSRP = () => {
        if (pricing && !isProductInventoryOnlyRole(roles) && !isPunchoutRole(roles)) {
            if (pricing.additionalResults?.msrpPrice !== null &&
                pricing.additionalResults?.msrpPrice !== "null") {
                    return (
                        <Typography {...styles.productPrice?.msrPriceTextStyle}>
                            <>MSRP {pricing.additionalResults?.msrpPriceDisplay}</>
                        </Typography>
                    )
            }
        }
    };

    if (isAuthenticated && isPendingVerification) {
        return (
            <>
                <Typography {...styles.pendingVerficationStyle} as="h1">
                    {translate("Account Pending Verification")}
                </Typography>
            </>
        );
    }
    const [accountPendingVerificatioPDP, setaccountPendingVerificatioPDP] = React.useState<string | null>("");

    const isPRRegion = typeof window !== "undefined" && window.location.hostname.endsWith(".pr");

    React.useEffect(() => {
        setaccountPendingVerificatioPDP(getCustomerCreditStatus?.getcustomerStatus?.creditStatus);
    }, [accountPendingVerificatioPDP, getCustomerCreditStatus?.getcustomerStatus?.creditStatus]);

    return (
        <>
            {!isAuthenticated ? (
                <StyledWrapper {...styles.beforeLoginRightSection}>
                    <Typography as="h1" {...styles.signInHeading}>
                        {translate("Sign In for Dealer Pricing")}
                    </Typography>
                    <Link href="/Accounts/BecomeACustomer" {...styles.signInLink}>
                        {translate("Become an ADI Customer")}
                    </Link>
                    <StyledWrapper {...styles.divider}></StyledWrapper>
                    <Button {...styles.loginToSeePriceButton} onClick={onLogintoSeePriceClick}>
                        {translate("Sign In")}
                    </Button>
                </StyledWrapper>
            ) : (
                <>
                    {pricingLoading ? (
                        <StyledWrapper {...styles.pricingMainWrapper}>
                            <ADIProductSaleInfo
                                product={product}
                                isAuthenticated={isAuthenticated}
                                extendedStyles={styles.pdpTagStyles}
                                pricing={pricing}
                            />
                            <Typography {...styles.realTimeText} data-test-selector="productPrice_unitNetPrice">
                                {/* Below text might be required in future */}
                                {/* {currencySymbol} */}
                                {""}
                            </Typography>
                        </StyledWrapper>
                    ) : pricingIsAvailable ? (
                        <>
                            <StyledWrapper {...styles.pricingMainWrapper}>
                                <ADIProductSaleInfo
                                    product={product}
                                    isAuthenticated={isAuthenticated}
                                    extendedStyles={styles.pdpTagStyles}
                                    pricing={pricing}
                                />
                                {accountPendingVerificatioPDP !== "O" &&
                                accountPendingVerificatioPDP !== "" &&
                                accountPendingVerificatioPDP !== null &&
                                accountPendingVerificatioPDP !== "null" ? (
                                    <Typography {...styles.VerificationText} as="span">
                                        {translate("Account Pending Verification")}
                                    </Typography>
                                ) : (
                                    <ProductPrice
                                        product={productContext}
                                        showLabel={false}
                                        showSavings={true}
                                        showSavingsAmount={productSettings.showSavingsAmount}
                                        showSavingsPercent={productSettings.showSavingsPercent}
                                        extendedStyles={styles.productPrice}
                                    />
                                )}
                            </StyledWrapper>
                            {!isPRRegion && displayMSRP()}
                            
                                {product.properties["inventoryMessage"] &&
                                product.properties["inventoryMessage"] === "DISCONTINUED" ? (
                                    <StyledWrapper><Typography {...styles.discontinuedmsg}>{discontiuedmsg} </Typography></StyledWrapper>
                                ) : null}
                            

                            {product.properties.pdpWebmessage && (
                                <StyledWrapper {...styles.pdpWebMessageStyles}>
                                    {parse(updatedPDPWebMessage, parserOptions)}
                                </StyledWrapper>
                            )}

                            {parseInt(product.properties.minimuM_QTY) > 1 ? (
                                <StyledWrapper {...styles.pdpMinimumQTYStyles}>
                                    Product is sold at minimum qty of {product.properties.minimuM_QTY}
                                </StyledWrapper>
                            ) : null}

                            {product.properties.classificatioN_CODE === "N" ? (
                                <StyledWrapper {...styles.pdpMinimumQTYStyles}>PRODUCT IS NON-RETURNABLE</StyledWrapper>
                            ) : null}
                        </>
                    ) : (
                        pricingError && (
                            <StyledWrapper {...styles.priceAvailibilityRightSection}>
                                {!isPendingVerification &&
                                    // <Typography as="h1">{translate("Pricing Currently Not Available")}</Typography>
                                    (accountPendingVerificatioPDP !== "O" &&
                                    accountPendingVerificatioPDP !== "" &&
                                    accountPendingVerificatioPDP !== null ? (
                                        <Typography>{translate("Account Pending Verification")}</Typography>
                                    ) : (
                                        <Typography as="h1">{translate("Pricing Currently Not Available")}</Typography>
                                    ))}
                            </StyledWrapper>
                        )
                    )}
                </>
            )}
        </>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(withProduct(withProductContext(ProductDetailsPrice))),
    definition: {
        displayName: "Price",
        group: "Product Details",
        allowedContexts: [ProductDetailsPageContext],
    },
};

export default widgetModule;
